import axios from 'axios';
import { Cookies } from 'react-cookie';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_RECEIPT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInst);

axiosInst.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

type OrderId = string | undefined;
type UseGetOTP = {
  otp: number | null;
};

export const receiptOtpRequest = async (orderId: OrderId) => {
  try {
    const response = await axiosInst.post(`/order/${orderId}/request`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const verifyReceiptOTP = async (orderId: OrderId, data: UseGetOTP) => {
  try {
    return await axiosInst.post(`/order/${orderId}/generate`, {
      otp: data.otp,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const sendReceiptService = async (orderId: OrderId, data: { choice: string }) => {
  try {
    return await axiosInst.post(`/order/${orderId}/send`, {
      choice: data.choice,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
